import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import "./style.css";

function DropZone({ setCsvFile }) {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    acceptedFiles,
    isDragAccept,
  } = useDropzone({
    accept: {
      "text/csv": [".csv"],
    },
  });
  const [files, setFiles] = useState();

  const sweet = window.sweet;

  useEffect(() => {
    if (!acceptedFiles.length) {
      return;
    }
    if (acceptedFiles[0]?.size > 1e7) {
      sweet({
        title: "INFO!",
        text: "Max 10 MB allowed",
        icon: "error",
      });
      setFiles();
      return;
    } else {
      setFiles(
        acceptedFiles.map((file) => (
          <li key={file.path}>
            {file.path} - {file.size} bytes
          </li>
        )),
      );
      console.log(acceptedFiles[0], "Ankur is coming here");
      setCsvFile(acceptedFiles[0]);
    }
  }, [acceptedFiles]);

  return (
    <div className="container">
      <div {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} />
        {isDragActive ? (
          isDragAccept ? (
            <p className="dropzone-content accepted">
              Release to drop the files here
            </p>
          ) : (
            <p className="dropzone-content rejected">
              Only .csv File are accepted
            </p>
          )
        ) : (
          <p className="dropzone-content">
            Drag and drop your files or
            <button className="browseButton">browse</button>
          </p>
        )}
      </div>
      <aside>
        <ul>{files}</ul>
      </aside>
    </div>
  );
}

export default DropZone;

<p className="dropzone-content">
  Drag and drop your files or
  <button className="browseButton">browse</button>
</p>;
